import search from './magnifyingGlass';

export const faSearch = search('classic', 'thin');
export const falSearch = search('classic', 'light');
export const fatSearch = search('classic', 'thin');
export const fadSearch = search('duotone', 'thin');
export const fasSearch = search('classic', 'solid');
export const farSearch = search('classic', 'regular');

export default search;
